export default "__VITE_ASSET__6jJsJFqALfPLhO5QJBlJcw__"